/*eslint-disable @typescript-eslint/no-unused-vars*/
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { createBreadCrumbProps, useEffectOnce } from '../../globalUtils/globalHooks'
import { CustomBreadCrumbs, CustomButtonGroup, CustomRadioForm, DashboardHeader, DashboardLoader, FilterProp, HorizontalNavbar, SelectDropDown, useAppDispatch, useAppSelector } from '../../globalUtils/globalExports'
import './addPlcLogConfiguration.css'
import { fetchChargersByCustomersByOrg, fetchPlcLogConfiguration, getReferenceDataReducer, getReportReducer, getUserReducer, updatePlcLogConfiguration } from '../../rmsReduxStore/reduxExports'
import { fetchChargerProductTypeReferenceData, fetchChargerStationReferenceData, fetchCustomerReferenceData, fetchStopReasonCodeReferenceData } from '../../rmsReduxStore/referenceDataRedux/referenceDataCreators'
import { FormLabel } from '@mui/material'
import { cloneDeep } from 'lodash'
import { useNavigate } from 'react-router-dom'
import { Id, toast } from 'react-toastify'

const AddPlcLogConfiguration: React.FC = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const navList = [
        { id: '1', text: 'Harmony Gen1.0' },
        { id: '2', text: 'EVM150' },
        { id: '3', text: 'Harmony Gen2.0'}
    ];

    const [selectedNav, setSelectedNav] = useState(navList[0]?.id);
    const [mode, setMode] = useState('Add');
    const [dataList, setDataList] = useState<string[]>([]);
    const {alertLogicStopReasonCodeRefData,customerReferenceData, chargerProductTypeReferenceData, chargingStationReferenceData } = useAppSelector(getReferenceDataReducer);
    const { chargerListByCustomerByOrg } = useAppSelector(getUserReducer);
    const [selectedRadioOption, setSelectedRadioOption] = useState('SelectChargers');
    const [selectedChargers, setSelectedChargers] = useState<string[]>([]); 
    const [initiallySelectedChargers, setInitiallySelectedChargers] = useState<string[]>([]);
    const [chargerCheckboxStates, setChargerCheckboxStates] = useState<string[]>([]);
    const [chargersChipValues, setChargersChipValues] = useState<string[]>([]);
    const [isSelectAllChargersChecked, setIsSelectAllChargersChecked] = useState(false);
    const [filters, setFilters] = useState<InnerFilterState[]>([
        {
          key: 'customer',
          value: null
        },
        {
          key: 'chargingStationId',
          value: null
        },
        {
          key: 'productType',
          value: null
        },
        {
          key: 'location',
          value: null
        },
        {
          key:'softwareVersion',
          value: null,
        }
    ]);
    const initiallySelectedStopReasons: Record<string,IGeneralReferenceData[]> = {
        '1': [],
        '2': [],
        '3': []
    };
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [productTypeWiseSelectedStopReason,setProductTypeWiseSelectedStopReasons] = useState<Record<string,IGeneralReferenceData[]>>(initiallySelectedStopReasons);
    const initialProductTypeWiseSelectedStopReasonRef = useRef(initiallySelectedStopReasons);

    const orgId = JSON.parse(localStorage.getItem('rms-user') || '{}').orgId;


    const breadCrumbs = createBreadCrumbProps({
        breadCrumbProps:
            [
                {
                    objectType: 'link',
                    id: 'sessionHistoryReport',
                },
                {
                    objectType: 'text',
                    id: 'text',
                    text: 'PLC Logs Configuration'
                }
            ]
        })

    const handleNavClick = useCallback((_,val)=>{
        const navTab = navList?.find(item => item?.id == val); 
        const productType = chargerProductTypeReferenceData?.filter(item => item?.name === navTab?.text );
        handleFilterDataChange(productType, 'productType')
        setSelectedNav(val);
    },[chargerProductTypeReferenceData])

    const handleStopCodeSelection = useCallback((val) => {
        setProductTypeWiseSelectedStopReasons(prev => ({
            ...prev,
            [selectedNav]: val
        }))
    },[selectedNav])

    // charger selection drop down methods and configuration
    const handleSelectedValues = (selectedChargers, selectedChargerChips, isChecked) => {
        setChargerCheckboxStates(selectedChargers)
        setSelectedChargers(selectedChargers);
        setChargersChipValues(selectedChargerChips);
        setIsSelectAllChargersChecked(isChecked);
    }

    const radioButtonList = [
        { radioButtonLabel: 'All Chargers', radioButtonId: 'AllChargers', isDisabled: mode === 'View' },
        { radioButtonLabel: 'Select Chargers', radioButtonId: 'SelectChargers', isDisabled: mode === 'View' },
    ]

    const handleRadioOptionChange = (event, value) => {
        setSelectedRadioOption(value);
        if (value === 'AllChargers') setSelectedChargers(['ALL'])
        else { setSelectedChargers(chargerCheckboxStates) }
    };


    const  radioButtonConfiguration = useMemo(() => {
        return {
          radionBtnGrpName: 'user__form_charger_options',
          buttonsList: radioButtonList,
          selectedRadioBtnValue: selectedRadioOption,
          handleSelectedRadioBtnChange: handleRadioOptionChange
        };
      }, [mode, selectedRadioOption, chargerCheckboxStates]);


    const chargerListCallback = useCallback((orgId, filters?, searchTerm?) => {
        let filtersToBeSent: Filters[] = []
        if (filters && filters?.length > 0) {
          filtersToBeSent = filters?.map((item) => {
            return {
              key: item.key,
              values: item.value?.map((item) => item.id) || []
            }
          })
        }
        dispatch(fetchChargersByCustomersByOrg({
          orgId: orgId,
          filters: filters ? filtersToBeSent : [],
          searchTerm: searchTerm != null && searchTerm != undefined ? searchTerm : ''
        }));
    }, [])


    const onSearchTextChange = useCallback((val) => {
        chargerListCallback?.(orgId, filters, val)
    }, [filters])

    const searchBoxConfiguration = useMemo(() => {
        return {
          searchFieldId: 'user__form_chargers-search-box',
          searchFieldName: 'user__form_chargers-search-box',
          isDisabled: mode === 'View',
          handleSearch: onSearchTextChange,
          searchBoxClassName: 'create__configure__notification__rule__charger_selection'
        };
    }, [onSearchTextChange, filters, mode])

    const handleFilterDataChange = useCallback((val, filterkey) => {
        const filtersToUpdate = cloneDeep(filters);
        const selectedFilter = filtersToUpdate?.find((filter) => filter?.key === filterkey);
        if (selectedFilter) {
          selectedFilter.value = Array.isArray(val) ? val : [val]
        }
        setFilters(filtersToUpdate);
        chargerListCallback?.(orgId, filtersToUpdate, '')
      }, [filters, chargerListCallback, setFilters])


    const chargerFilterProps: FilterProp[] = useMemo(() => {
        return [
          {
            filterLabel: 'Customer',
            filterType: 'dropdown',
            filterId: 'Customer',
            filterDropdownProps: {
              selectValue: filters?.find((filter) => filter?.key === 'customer')?.value,
              selectOptions: customerReferenceData ?? [],
              handleSelectOptionChange: (val): void => {
                handleFilterDataChange(val, 'customer')
              },
              selectDropDownId: 'charger-customer-filter-dropdown',
              isMultiSelect: true,
              isDisabled: mode === 'View',
              renderToBody: true,
            }
          },
          {
            filterLabel: 'Charging Station',
            filterType: 'dropdown',
            filterId: 'chargingStationId',
            filterDropdownProps: {
              selectValue: filters?.find((filter) => filter?.key === 'chargingStationId')?.value,
              selectOptions: chargingStationReferenceData ?? [],
              handleSelectOptionChange: (val): void => {
                handleFilterDataChange(val, 'chargingStationId')
              },
              selectDropDownId: 'charger-location-filter-dropdown',
              isMultiSelect: true,
              isDisabled: mode === 'View',
              renderToBody: true
            }
          },
          {
            filterLabel: 'Product Type',
            filterType: 'dropdown',
            filterId: 'ProductType',
            filterDropdownProps: {
              selectValue: filters?.find((filter) => filter?.key === 'productType')?.value,
              selectOptions: chargerProductTypeReferenceData ?? [],
              handleSelectOptionChange: (val): void => {
                handleFilterDataChange(val, 'productType')
              },
              selectDropDownId: 'charger-location-filter-dropdown',
              isMultiSelect: true,
              isDisabled: true,
              renderToBody: true
            }
          }
        ]
    }, [customerReferenceData, chargingStationReferenceData, chargerProductTypeReferenceData, filters, mode])

    const formSuccessToast = (): Id => toast.success('PLC logs configuration updated.');
    const formErrorToast = (msg) : Id => toast.error(msg);

    const handleSubmit = useCallback(async () => {
        setIsSaving(true);
        const reqBody = {
            productType1SelectedEnums: productTypeWiseSelectedStopReason?.['1']?.map(item => item?.id),
            productType2SelectedEnums: productTypeWiseSelectedStopReason?.['2']?.map(item => item?.id),
            productType3SelectedEnums: productTypeWiseSelectedStopReason?.['3']?.map(item => item?.id),
            chargers: selectedChargers
        }

        const response = await updatePlcLogConfiguration(reqBody);

        if(response?.status === 200 || response?.status === 202 ) {
            setIsSaving(false);
            formSuccessToast();
            navigate('/sessionHistory');
        } else {
            setIsSaving(false);
            formErrorToast(response?.data?.message);
        }
    },[productTypeWiseSelectedStopReason,selectedChargers]);

    function arraysAreEqual<T>(arr1?: T[], arr2?: T[]): boolean {
        if (!arr1 || !arr2 || arr1?.length !== arr2?.length ) {
            return false;
        }
        return arr1.every((value, index) => value === arr2[index]);
    }

    const disableSubmitButton = useMemo(() => {
        const productType1SelectedEnums = productTypeWiseSelectedStopReason?.['1']?.map(item => item?.id);
        const productType2SelectedEnums = productTypeWiseSelectedStopReason?.['2']?.map(item => item?.id);
        const productType3SelectedEnums = productTypeWiseSelectedStopReason?.['3']?.map(item => item?.id);

        const productType1InitialSelectedEnums = initialProductTypeWiseSelectedStopReasonRef?.current?.['1']?.map(item => item?.id);
        const productType2InitialSelectedEnums = initialProductTypeWiseSelectedStopReasonRef?.current?.['2']?.map(item => item?.id);
        const productType3InitialSelectedEnums = initialProductTypeWiseSelectedStopReasonRef?.current?.['3']?.map(item => item?.id);

        return ( 
            arraysAreEqual(productType1SelectedEnums,productType1InitialSelectedEnums) && 
            arraysAreEqual(productType2SelectedEnums,productType2InitialSelectedEnums) && 
            arraysAreEqual(productType3SelectedEnums,productType3InitialSelectedEnums) && 
            arraysAreEqual(selectedChargers, initiallySelectedChargers)
        )

    },[productTypeWiseSelectedStopReason,initialProductTypeWiseSelectedStopReasonRef, selectedChargers, initiallySelectedChargers])

    const footerButtonList = useMemo(() => {
    return [
        {
        buttonText: 'Save',
        buttonId: 'submit',
        btnClassName: disableSubmitButton ? 'primary__btn disabled' : 'primary__btn',

        handleClick: (): void => {
            handleSubmit()
        },
        isDisabled: disableSubmitButton,
        buttonVariant: 'filled',
        },
        {
        buttonText: 'Cancel',
        buttonId: 'cancel',
        btnClassName: 'secondary__btn',
        handleClick: (): void => {
            navigate('/sessionHistory')
        },
        isDisabled: false,
        buttonVariant: 'outlined',
        },
    ];
    }, [disableSubmitButton, handleSubmit, mode]);

    useEffect(() => {
        const chargerData = chargerListByCustomerByOrg?.map((item) => {
          return {
            header: item?.customerName,
            count: item?.chargers?.length,
            data: item?.chargers?.map((charger) => charger?.visibleId)
          }
        }) || []
    
        const dataList = chargerData?.flatMap(({ header, count, data }) => [
          (header !== undefined && count !== undefined) ? `${header} (${count})` : '',
          ...data
        ]).filter(item => item !== '');
        const uniqueDataList = Array.from(new Set(dataList));
        setDataList(uniqueDataList);
    }, [chargerListByCustomerByOrg])

    useEffect(() => {
        if(!chargerProductTypeReferenceData?.length) return;
        const navTab = navList?.[0]; 
        const defaultProductType = chargerProductTypeReferenceData?.filter(item => item?.name === navTab?.text );
        handleFilterDataChange(defaultProductType, 'productType')
    },[chargerProductTypeReferenceData])

    useEffectOnce(()=>{
        setIsLoading(true);
        dispatch(fetchStopReasonCodeReferenceData());
        dispatch(fetchCustomerReferenceData());
        dispatch(fetchChargerStationReferenceData());
        dispatch(fetchChargerProductTypeReferenceData());
        dispatch(fetchPlcLogConfiguration()).then(data => {
            setSelectedChargers(data.chargers);
            setChargersChipValues(data?.chargers);
            setChargerCheckboxStates(data?.chargers);
            setInitiallySelectedChargers(data.chargers);
            initialProductTypeWiseSelectedStopReasonRef.current = {
                '1': data.productType1StopReasons,
                '2': data.productType2StopReasons,
                '3': data.productType3StopReasons
            }
            setProductTypeWiseSelectedStopReasons(initialProductTypeWiseSelectedStopReasonRef?.current);
            setIsLoading(false);
        })
    })

    const filteredSelectedChips = useMemo(() => {
        if (!chargersChipValues?.length || !dataList?.length) {
            return [];
        }
        const dataListSet = new Set(dataList);
        return chargersChipValues.filter(item => dataListSet.has(item));
    }, [dataList, chargersChipValues]);

    return (
        <>
        <DashboardLoader showLoader={isSaving} />
        <div className='plc_log_configuration_dashboard_wrap'>
            <CustomBreadCrumbs breadCrumbs={breadCrumbs} />
            <div className='plc_log_configuration_dashboard_header'>
                <DashboardHeader header='PLC Logs Configuration'/> 
            </div>
            <div className='plc_log_configuration_dashboard_body'>
                <div className='plc_log_configuration_dashboard_navbar'>
                    <HorizontalNavbar
                        navList={navList}
                        selectedNav={selectedNav}
                        onNavClick={handleNavClick}
                    />
                </div>
                <div className='plc_log_configuration_stop_code_dropdown_container'>
                    <FormLabel className={'rms-form-label'}>Stop Reasons</FormLabel>
                    <SelectDropDown 
                        selectDropDownId={'configure__stop__reasons__dropdown'}
                        dropDownClassName={'plc_log_configuration_stop_code_dropdown'}
                        selectOptions={alertLogicStopReasonCodeRefData ?? []}
                        handleSelectOptionChange={handleStopCodeSelection}
                        selectValue={productTypeWiseSelectedStopReason?.[selectedNav] ?? []}
                        isMultiSelect={true}
                        isDisabled={isLoading}
                        placeholder={isLoading ? 'Loading...' : 'Select stop reasons'}
                        renderToBody={true}
                    />
                </div>
                <div className='plc_log_configuration_stop_code_charger_selection_container'>
                    <CustomRadioForm
                        key={selectedRadioOption}
                        smallerFont={true}
                        formContainerClass={'user__form__charger-selection'}
                        header={'Charger Selection'}
                        dataList={dataList || []}
                        individualCheckboxStates={chargerCheckboxStates}
                        selectedChipValues={filteredSelectedChips}
                        selectAllChecked={isSelectAllChargersChecked}
                        handleSelectedData={handleSelectedValues}
                        filterProps={chargerFilterProps}
                        radioButtonConfiguration={radioButtonConfiguration}
                        searchBoxConfiguration={searchBoxConfiguration}
                        disableCheckBox={isLoading}
                        showRadioList={selectedRadioOption === 'SelectChargers'}
                        radioButtonConfigNotRequired={true}
                        isCustom={true}
                        removePadding={true}
                    />
                </div>
            </div>
            <div className='user__form__wrap-footer'>
                <CustomButtonGroup
                    buttonsList={mode === 'View' ? footerButtonList?.filter((button) => button?.buttonId === 'cancel') : footerButtonList}
                    buttonGroupClassName='button__group__footer'
                />
            </div>
        </div>
        </>
    )
}

export default AddPlcLogConfiguration

